// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whitepaper-viewer {
  min-height: 100vh;
  background: #0f1114;
  color: #fff;
  user-select: none;
  -webkit-user-select: none;
}

.whitepaper-viewer__header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background: rgba(15, 17, 20, 0.96);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.whitepaper-viewer__logo {
  height: 28px;
  width: auto;
}

.whitepaper-viewer__header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.whitepaper-viewer__header p {
  margin: 0 0 0 auto;
  font-size: 12px;
  opacity: 0.65;
}

.whitepaper-viewer__loading,
.whitepaper-viewer__error {
  padding: 24px;
  text-align: center;
  font-size: 14px;
}

.whitepaper-viewer__error {
  color: #ff6b6b;
}

.whitepaper-viewer__pages {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px 16px 40px;
}

.whitepaper-page {
  display: block;
  max-width: 100%;
  height: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  pointer-events: none;
}

body.light_theme .whitepaper-viewer {
  background: #f5f7fa;
  color: #111;
}

body.light_theme .whitepaper-viewer__header {
  background: rgba(255, 255, 255, 0.96);
  border-bottom-color: rgba(0, 0, 0, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Whitepaper/whitepaper.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C","sourcesContent":[".whitepaper-viewer {\n  min-height: 100vh;\n  background: #0f1114;\n  color: #fff;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.whitepaper-viewer__header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 24px;\n  background: rgba(15, 17, 20, 0.96);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.whitepaper-viewer__logo {\n  height: 28px;\n  width: auto;\n}\n\n.whitepaper-viewer__header h1 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.whitepaper-viewer__header p {\n  margin: 0 0 0 auto;\n  font-size: 12px;\n  opacity: 0.65;\n}\n\n.whitepaper-viewer__loading,\n.whitepaper-viewer__error {\n  padding: 24px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.whitepaper-viewer__error {\n  color: #ff6b6b;\n}\n\n.whitepaper-viewer__pages {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 16px 40px;\n}\n\n.whitepaper-page {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  pointer-events: none;\n}\n\nbody.light_theme .whitepaper-viewer {\n  background: #f5f7fa;\n  color: #111;\n}\n\nbody.light_theme .whitepaper-viewer__header {\n  background: rgba(255, 255, 255, 0.96);\n  border-bottom-color: rgba(0, 0, 0, 0.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
